export default __webpack_public_path__ + "static/sparkle-social-29e8ebe0c0c655b64e09fcc773d9842b.jpg";